
export const services = {
  "subtitle-de": "WANN TREFFEN WIR UNS?",
  "header-de": "Gemeinschaft jede Woche",
  "subtitle-ro": "CÂND NE ÎNTÂLNIM?",
  "header-ro": "Părtășie în fiecare săptămână",
  wednesday: {
    "day-de": "MITTWOCH",
    "day-ro": "MIERCURI",
    time: "19:00 - 21:00",
    "type-de": "Gebetsabend",
    "type-ro": "Seara de rugăciune",
    "description-de": "Wir treffen uns gemeinsam zu einem speziellen Gebetsabend. Wir glauben, dass Gott unsere Gebete erhört.",
    "description-ro": "Ne întâlnim împreună pentru o seară specială de rugăciune. Credem că Dumnezeu ne răspunde la rugăciuni."
  },
  sunday: {
    "day-de": "SONNTAG",
    "day-ro": "DUMINICĂ",
    time1: "09:30 - 12:00",
    "type1-de": "Morgen - Gottesdienst",
    "type1-ro": "Morgen - Slujbă",
    "description1-de": "Unsere Hauptversammlung hat das Ziel, ein Rückblick auf die Woche mit Gott zu geben und uns für die kommende Woche voller Herausforderungen vorzubereiten.",
    "description1-ro": "Serviciul nostru de duminică își propune să ne pregătească pentru săptămâna viitoare.",
    time2: "17:30 - 19:30",
    "type2-de": "Abend - Gottesdienst",
    "type2-ro": "Serviciu de seară",
    "description2-de": "Am ersten Sonntag des Monats ist der Abend-Gottesdienst speziell für Jugendliche.",
    "description2-ro": "Slujba de seară din prima duminică a săptămânii este specială pentru tineri"
  },
  friday: {
    "day-de": "FREITAG",
    "day-ro": "VINERI",
    time: "18:45 - 21:00",
    "type-de": "Jugendtreffen",
    "type-ro": "Întâlnire de tineret",
    "description-de": "Jugendlichen treffen sich jeden Freitag in der Gemeinde.",
    "description-ro": "Tinerii se întâlnesc în comunitate în fiecare vineri."
  },
}
